import React from 'react'
import { BeatLoader } from  'react-spinners'

export default function Loader({colorCode, size}) {
    return (
        <BeatLoader color={colorCode === undefined ? "#ffff" : colorCode} size={size === undefined ? "10px" : size} />

    )
}
